import Onboard from "../js/components/groupManagement/Onboard.react";
export default Onboard;
